import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';

import { DynamicComponentDirective, MenuContentItem } from '@frontend/vanilla/core';
import { BonusBalanceService } from '@frontend/vanilla/features/bonus-balance';

import { AccountMenuItemBase } from '../account-menu-item-base';

@Component({
    imports: [CommonModule, DynamicComponentDirective],
    selector: 'vn-bonus-balance-header',
    templateUrl: './bonus-balance-header.component.html',
})
export class BonusBalanceHeaderComponent extends AccountMenuItemBase implements OnInit {
    private bonusBalanceService = inject(BonusBalanceService);

    balanceItems: MenuContentItem[];
    ctaItems: MenuContentItem[];

    ngOnInit() {
        this.bonusBalanceService.refresh();

        if (this.item.children) {
            this.balanceItems = this.item.children.filter((x) => x.type !== 'cta');
            this.ctaItems = this.item.children.filter((x) => x.type === 'cta');
        }
    }
}
